import { ProfileTypes } from "./actionTypes"

const initialState = {
  data: null,
  error: "",
  success: "",
  loading: false,
  updating: false,
}

const profile = (state = initialState, action : any) => {
  switch (action.type) {
    case ProfileTypes.GET_PROFILE:
      state = { ...state, loading: true, error: "" }
      break
    case ProfileTypes.GET_PROFILE_SUCCESS:
      state = { ...state, data: action.payload, loading: false, error: "" }
      break
    case ProfileTypes.EDIT_PROFILE:
      state = { ...state, updating: true, error: "" }
      break
    case ProfileTypes.PROFILE_SUCCESS:
      state = { ...state, success: action.payload, updating: false }
      break
    case ProfileTypes.PROFILE_ERROR:
      state = { ...state, error: action.payload, loading: false, updating: false }
      break
    case ProfileTypes.RESET_PROFILE_FLAG :
      state = { ...state, success: "", error: "" }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default profile
